import axios from 'axios'
import getConfigDetails  from './config'
const axiosClient = axios.create()

// Intercept request
// const client_id = JSON.parse(localStorage.getItem('client_id'))

axiosClient.interceptors.request.use(
	(request) => {
		const user = localStorage.getItem('userData') || localStorage.getItem('sign_in') || localStorage.getItem('sign_up')
		const userData = JSON.parse(user || '{}')
		request.headers['Content-Type'] = 'application/json'
		userData?.access_token ? request.headers['Authorization'] = `Bearer ${userData?.access_token}` : ''
		// request.headers['X-ClientSecret'] = client_id?.secret ? client_id.secret : getConfigDetails?.CLIENT_SECRET ? getConfigDetails?.CLIENT_SECRET : ''
		request.headers['X-ClientSecret'] = getConfigDetails?.CLIENT_SECRET
		return request
	},
	null,
	{ synchronous: true }
)

// Intercept response
axiosClient.interceptors.response.use(
	(response) => {
		// Dispatch any action on success
		if (response?.status == 201 || response?.status == 200) {
			return response?.data
		} else {
			return Promise.reject(response?.data)
		}
	}
	,
	(error) => {

		return Promise.reject(error?.response?.data)

	}
)

// 

// axiosClient.defaults.baseURL ="";

axiosClient.defaults.headers = {
	'Content-Type': 'application/json',
	Accept: 'application/json',
}

// All request will wait 1 min before timeout
axiosClient.defaults.timeout = 60000

// axiosClient.defaults.withCredentials = true;

export default axiosClient